import React from 'react'
import BillingHistory from './billing-history'
import PaymentMethod from './billing-payment'
import RecentPayment from './billing-recent'
import PaymentInfo from '../modals/payment-info-modal'
import {fetchLatestBillingHistory} from '../api'
import {getDateFromMillis} from '../shared/enums/date-parser'
import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'
import NotificationModal from '../modals/notification-modal'
import ReactGA from 'react-ga'

export default React.createClass({
  getInitialState: function () {
    return {
      showPaymentInfoModal: false,
      mostRecentPayment: -1,
      mostRecentDate: '',
      mostRecentTask: 'No history to display',
      billingCard: '',
      showNotificationModal: false,
      notificationTitle: '',
      notificationContent: '',
    }
  },
  componentDidMount: function () {
    if(this.props.loginData.customer.paymentProfile) {
      this.setState({billingCard: this.props.loginData.customer.paymentProfile.billingCardNumber})
    }
    this.getLatestBilling()
  },
  getLatestBilling: function() {
    fetchLatestBillingHistory().then((data) => {
      console.log("Latest", data);
      let prettyTaskType = getTaskTypeIconParser(data.taskType).prettify
      this.setState({mostRecentPayment: data.amount, mostRecentDate: data.date, mostRecentTask: prettyTaskType})
    })
  },
  //Start of opening modals
  openPaymentInfo: function () {
    ReactGA.pageview("PaymentInfoModal")
    this.setState({showPaymentInfoModal: true})
  },
  closePaymentInfo: function () {
    this.setState({showPaymentInfoModal: false})
  },
  openNotificationModal: function(closingModal, notificationTitle, notificationContent) {
    ReactGA.pageview('NotificationModal');
    this.setState({showNotificationModal: true, [closingModal]: false, notificationTitle: notificationTitle, notificationContent: notificationContent})
  },
  closeNotificationModal: function() {
    this.setState({showNotificationModal: false})
  },
  //End of opening modals
  
  render: function () {
    if (!this.props.loginData) {
      return (<div />)
    }
    let loginData = this.props.loginData
    let customerAddresses = []
    for (let i = 0; i < loginData.customer.addresses.length; i++) {
      let customerAddress = loginData.customer.addresses[i].streetAddress
      customerAddresses.push(customerAddress)
    }
    return (
      <div>
        <PaymentInfo show={this.state.showPaymentInfoModal} hide={this.closePaymentInfo} loginData={this.props.loginData} openNotificationModal={this.openNotificationModal}/>
        <NotificationModal hide={this.closeNotificationModal} show={this.state.showNotificationModal} title={this.state.notificationTitle} content={this.state.notificationContent}/>

        <div className='container-cards'>
          <div className='row'>
            <div className='col-xs-12 history-wrap'>
              <div className='row pull-down-sm-1'>
                <div className='col-sm-5 col-xs-12'>
                  <h3 className='hidden-xs' style={{textAlign: 'left'}}>Billing</h3>
                  <h3 className='visible-xs'>Billing</h3>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-6 text-center pull-down-sm-1'>
              <RecentPayment payAmt={this.state.mostRecentPayment} payDate={getDateFromMillis(this.state.mostRecentDate)} paySubject={this.state.mostRecentTask} />
            </div>
            <div className='col-sm-6 text-center pull-down-xs-1'>
              <PaymentMethod cardType='Visa' cardNumEnd={this.state.billingCard} btnOnClick={this.openPaymentInfo} />
            </div>
          </div>
          <div className="row pull-down-xs-1">
            <div className='col-xs-12'>
              <BillingHistory address={this.props.currentAddress} billingHistory={this.props.billingHistory}/>
            </div>
          </div>
            {/*<div className='col-xs-12 visible-xs-block pull-down-xs-2'>*/}
              {/*<div className='col-xs-12'>*/}
                {/*<RecentPayment payAmt={this.state.mostRecentPayment} payDate={getDateFromMillis(this.state.mostRecentDate)} paySubject={this.state.mostRecentTask} />*/}
              {/*</div>*/}
              {/*<div className='col-xs-12 pull-down-xs-2'>*/}
                {/*<BillingHistory />*/}
              {/*</div>*/}
              {/*<div className='col-xs-12' style={{marginBottom: 20, marginTop: -35}}>*/}
                {/*<PaymentMethod cardType='Visa' cardNumEnd={this.state.billingCard} btnOnClick={this.openPaymentInfo} />*/}
              {/*</div>*/}
            {/*</div>*/}
          </div>
      </div>
    )
  }

})



// WEBPACK FOOTER //
// ./src/components/billing/billing.jsx